import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { ConfigService } from "../config/config.service";
import { EventsService } from "../event/event.service";
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';
import { CustomerModel } from 'src/app/models/customer-model';
import { DailySpinModel } from 'src/app/models/daily-spin-model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import type { PlatformResponse } from "src/app/interfaces/webservices-interface";

@Injectable({
  providedIn: "root",
})

export class DailySpinService {
  public customer: CustomerModel;
  public gameUrl: String = "";
  public numSpins : String = "0";
  _dailySpinSubject: BehaviorSubject<DailySpinModel>;
  constructor(
    private platform: Platform,
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    public config: ConfigService,
    public navigator: Navigator,
  ) {
    this._dailySpinSubject = new BehaviorSubject(undefined);
    this.userSession.getCustomer().subscribe(
      customer => {
        this.customer = customer;
      }
    )
   }

  async initDailyBonusGame() {
    try {
      const data = await Promise.all([this.initDailyBonus(), this.setDailySpinGameUrl()]);
      if(!!data && !!data[0] && data[0].result == 1){
        if(!!data[1] && !!data[1].payload){
          this.gameUrl = data[1].payload;
        } else{
          this.gameUrl = "";
          this.numSpins = "0";
        }
        return true;
      } else{
        return false;
      }
    } catch(e) {
      console.error(e);
      return false;
    }
  }

  async initDailyBonus() {
    try {
      let data = await Promise.resolve(this.initDailyBonusFunction());
      return data;
    } catch(e) {
      console.error(e);
      return false;
    }
  }

  async initDailySpinGameUrl() {
    try {
      let data = await Promise.resolve(this.setDailySpinGameUrl());
      this.gameUrl = data.payload;
      return data;
    } catch(e) {
      console.error(e);
      return false;
    }
  }

  initDailyBonusFunction() {
    return this.initDailyBonusCall().toPromise();
  }

  setDailySpinGameUrl() {
    return this.setDailySpinGameUrlCall().toPromise();
  }

  getDailyBonus(){
    return this._dailySpinSubject;
  }

  initDailyBonusCall():Subject<PlatformResponse<any>> {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }
    return this.webservices.post('rewards/init-daily-bonus', obj);
  }

  setDailySpinGameUrlCall():Subject<PlatformResponse<any>> {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken()
    }
    return this.webservices.get('rewards/launch-daily-bonus', obj);
  }


  getDailySpinGameUrl(){
    return this.gameUrl;
  }

}
